import { FC } from "react";
import { useRecoilState } from "recoil";
import myInfoState from "../../../atoms/myinfo";
import "./Room.scoped.scss"

interface RoomProps {
  thumbnailUrl: string;
  name: string;
  participants: number;
  maxParticipants: number;
  ownerLevel: number;
  ownerName: string;
  roomId: string;
  isSecret: boolean;
}

const Room: FC<RoomProps> = ({
  thumbnailUrl,
  name,
  participants,
  maxParticipants,
  ownerLevel,
  ownerName,
  roomId,
  isSecret,
}) => {
  const [myInfo] = useRecoilState(myInfoState);

  const enterRoom = () => {
    if (isSecret) {
      window.alert('비밀방은 채팅 대기실을 통해 입장해주세요.');
    } else {
      if (myInfo.userDetail?.id == null || myInfo.userDetail?.id === '') {
        window.alert('로그인 후 이용해주세요.');
      } else {
        window.open(
          `/chatting-app/room/${roomId}`, 
          'Room', 
          'width=940px,height=640px,status=no,scrollbars=no,toolbar=no'
        );
      }
    }
  }
  return (
    <div className="room">
      <div className="room__thumbnail" onClick={enterRoom}>
        <img src={thumbnailUrl} alt="" />
      </div>
      <div className="room__contents">
        <div className="room__title-and-time">
          <div className="room__title" onClick={enterRoom}>
            {name}
            {
              isSecret
                ? (
                  <span className="room__secret-simbol">[비밀방]</span>
                )
                : null
            }
          </div>
          {/*<div className="room__time">44분전</div>*/}
        </div>
        <div className="room__visitor-and-master">
          <div className="room__visitor"><b>{participants}</b> / {maxParticipants}</div>
          <div className="room__master">
            <img src={`/img/level/level_img/${ownerLevel}.png`} alt="" />
            <span>{ ownerName }</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Room;